import React, { memo } from 'react';
import AttachmentIcon from '@mui/icons-material/Attachment';
import DeleteIcon from '@mui/icons-material/Delete';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { Checkbox, FormControlLabel, IconButton, TableCell, TableRow } from '@mui/material';
import moment from 'moment';
import { useSelector } from 'react-redux';

function DataTable({ payments, onSlip, onEdit, onDelete, onChangePaymentStatus }) {
    let { user } = useSelector((state) => state?.user);

    return (
        <>
            {!!payments &&
                payments?.map((row) => (
                    <TableRow
                        key={row._id}
                        sx={{
                            '&:last-child td, &:last-child th': { border: 0 }
                            // '&:hover': { bgcolor: '#f0f0f0', cursor: 'pointer' }
                        }}
                    >
                        <TableCell width={200}>{moment(row?.createdOn).format('MMM DD, YYYY')}</TableCell>
                        <TableCell>{row?.verifiedAt ? moment(row?.verifiedAt).format('MMM DD, YYYY') : '-'}</TableCell>
                        <TableCell>{row?.customer?.name}</TableCell>
                        <TableCell>{row?.amount}</TableCell>
                        <TableCell>{row?.vendor?.name}</TableCell>
                        <TableCell component="th" scope="row">
                            {row?.bank?.name}
                        </TableCell>
                        <TableCell>{row?.refNo}</TableCell>
                        <TableCell>{row?.comments}</TableCell>
                        <TableCell>
                            {row?.user?.firstName} {row?.user?.lastName}
                        </TableCell>
                        <TableCell>
                            {row?.slip && (
                                <IconButton onClick={() => onSlip(row)} size="small" color="inherit" style={{ paddingVertical: -10 }}>
                                    <AttachmentIcon style={{ fontSize: 20 }} />
                                </IconButton>
                            )}
                        </TableCell>

                        {(user?.email == 'imran-saleem@kkfoods.com' || user?.role == 'super-admin' || user?.role == 'cash-payments' || user?.role == 'account') && (
                            <TableCell>
                                <IconButton onClick={() => onEdit(row)} aria-label="Edit" size="small">
                                    <BorderColorIcon sx={{ color: '#1976d2' }} />
                                </IconButton>
                            </TableCell>
                        )}

                        {user?.role == 'cash-payments' && (
                            <TableCell>
                                <FormControlLabel
                                    control={<Checkbox checked={row?.paymentVerified} onChange={() => onChangePaymentStatus(row)} />}
                                    label={row?.paymentVerified ? 'Verified' : 'Unverified'}
                                />
                            </TableCell>
                        )}

                        <TableCell>
                            <IconButton onClick={() => onDelete(row)} aria-label="Delete" size="small">
                                <DeleteIcon sx={{ color: 'red' }} />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                ))}
        </>
    );
}

export default memo(DataTable);
